export default __webpack_public_path__ + "static/media/diamond-sharp.684462d4.svg";